<template>
  <fragment>
    <div class="form-group mb-0">
      <label
        class="p-0"
        for="phone-input"
        style="top: 5px; position: relative; color: rgba(0, 0, 0, 0.6)"
        >{{ label }}</label
      >
      <input
        :id="inputId"
        ref="phone-input"
        v-model="number"
        :disabled="readonly"
        class="form-control"
        type="text"
        @change="changePhone"
        @input="handleInputChange"
      />
      <span v-if="errors" class="text-danger" v-html="errors"></span>
    </div>
    <v-text-field :error-messages="errors" style="display: none"></v-text-field>
  </fragment>
</template>

<script>
import intlTelInput from "intl-tel-input";

export default {
  name: "SMPhoneSelectbox",
  props: {
    phone: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: "Telefon Numarası",
    },
    id: {
      type: String,
      default: "phone-input",
    },
    validatable: {
      type: Boolean,
      default: false,
    },
    validateId: Number,
    isFormValid: Boolean,
    checkUserPhone: String,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      number: null,
      lastNumber: null,
      errors: "",
      phoneInput: null,
    };
  },
  mounted() {
    this.phoneInput = intlTelInput(this.$refs["phone-input"], {
      initialCountry: "TR",
      formatOnDisplay: true,
      preferredCountries: ["TR"],
      dropdownContainer: document.body,
      utilsScript:
        "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/18.1.6/js/utils.min.js",
    });

    this.number = this.phone ?? null;
  },
  methods: {
    async handleInputChange() {
      this.errors = null;

      if (!this.phoneInput.isValidNumber()) {
        this.errors = "Telefon numarası geçerli değil";
        return;
      }

      const phone = this.phoneInput.getNumber();

      if (this.checkUserPhone && this.checkUserPhone === phone) {
        this.errors = "Bu numara, sizin numaranızla aynı olamaz.";
      }

      if (this.validatable) {
        try {
          await this.$apiService.post("/phone/verify", {
            user_id: this.validateId,
            phone,
          });
        } catch (error) {
          this.errors = "Bu telefon numarası zaten kayıtlı";
          return;
        }
      }

      this.lastNumber = phone;
    },
    changePhone() {
      this.$emit("update:phone", this.lastNumber);
    },
  },
  computed: {
    inputId() {
      return this.id || "phone-input";
    },
  },
  watch: {
    phone(newVal) {
      this.number = newVal;
    },
  },
};
</script>
